import React from 'react';
import { classNames } from '../../utils/classNames';
import { Tooltip } from '../../components/ui/Tooltip';
import { useI18n } from '../../hooks/useI18n';
import { TemporaryChatIcon } from './TemporaryChatIcon';

export const TemporaryChatButton = ({ active = false, disabled = false, onClick }) => {
  const { t } = useI18n();

  return (
    <Tooltip content={t('chatTemporary')} position="bottom" align="end">
      <button
        type="button"
        disabled={disabled}
        aria-pressed={active}
        aria-label={t('chatTemporary')}
        onClick={onClick}
        className={classNames(
          'inline-flex h-9 w-9 items-center justify-center rounded-full border transition disabled:cursor-not-allowed disabled:opacity-50',
          active
            ? 'border-dashed border-[#7B8CDE] bg-[#E8EEF8] text-[#4F63C7] dark:border-[#7B8CDE]/70 dark:bg-[#1B2438] dark:text-[#A8B6F0]'
            : 'border-transparent text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900 dark:text-muted dark:hover:bg-accent-soft dark:hover:text-text'
        )}
      >
        <TemporaryChatIcon size={22} animated />
      </button>
    </Tooltip>
  );
};
